module.exports = __webpack_public_path__ + "static/img/6-2.dc8222c4.png";